export const EMPY_FEEDBACK = '/api/feedbacks/v1/send';
export const EMPY_CONTACT_US = '/api/contactus/v1/send';
export const EMPY_CHAT = '/api/v1/empy/query';
